"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueEnum = void 0;
var QueueEnum;
(function (QueueEnum) {
    QueueEnum["Elastic"] = "ElasticQueue";
    QueueEnum["Statistics"] = "Statistics";
    QueueEnum["Imap"] = "Imap";
    QueueEnum["Smtp"] = "Smtp";
    QueueEnum["ConversationHandler"] = "ConversationHandlerQueue";
    QueueEnum["JourneyHandler"] = "JourneyHandlerQueue";
    QueueEnum["QueueHandler"] = "QueueHandlerQueue";
    QueueEnum["AuditHandler"] = "AuditHandler";
    QueueEnum["ListFileProcessor"] = "ListFileProcessor";
    QueueEnum["QueueAssigned"] = "QueueAssigned";
    QueueEnum["QueueDistribution"] = "QueueDistribution";
    QueueEnum["NotificationTimedOut"] = "NotificationTimedOut";
    QueueEnum["InvoiceHandler"] = "InvoiceHandler";
    QueueEnum["GdprHandler"] = "GdprHandler";
})(QueueEnum = exports.QueueEnum || (exports.QueueEnum = {}));
